module.exports = __webpack_public_path__ + "static/media/delete-icon.6a1c5f38.svg";